import { IconAdd } from '@consta/icons/IconAdd'
import { IconUpload } from '@consta/icons/IconUpload'

import { createNotFound } from './NotFound'

export const NotFoundSpeedLawInWell = createNotFound('NotFoundSpeedLawInWell', {
  description: 'В скважине нет скоростных законов',
  actionLabel: 'Добавить скоростной закон',
  actionIcon: IconAdd,
})

export const NotFoundSearch = createNotFound('NotFoundSearch', {
  title: 'Ничего не найдено:(',
  description: 'Попробуйте другой запрос',
})

export const NotFoundWellInProject = createNotFound('NotFoundWellInProject', {
  description: 'В проекте еще нет скважин',
  actionLabel: 'Загрузка файлов',
  actionIcon: IconUpload,
  remoteActionId: 'Загрузка файлов',
})

export const NotFoundWellInField = createNotFound('NotFoundWellInField', {
  description: 'В месторождении еще нет скважин',
  actionLabel: 'Загрузка файлов',
  actionIcon: IconUpload,
  remoteActionId: 'Загрузка файлов',
})
